import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { LoginService } from '../services/login/login.service';

@Directive({
  selector: '[appShowHavePermission]',
  standalone: true
})
export class ShowHavePermissionDirective {
  @Input('appShowHavePermission') allowedPermission!: string;

  constructor(
    private loginService: LoginService,
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>
  ) {}

  ngOnInit() {
    this.hasPermission();
  }

  hasPermission() {
    const userPermission = this.loginService.userPermission;
    if (
      userPermission?.includes(this.allowedPermission) ||
      !this.allowedPermission
    ) {
      this.viewContainerRef.clear();
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }
}
